import { ApiService } from './../../services/http/api.service';
import { Component, Input } from '@angular/core';
import { OnInit } from '@angular/core';
import { Buffer } from "buffer";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-image',
  template: `<img style="object-fit: contain;" class="tool-photo" [src]="url" />`
})

export class ImageComponent implements OnInit {
  @Input() idImage: string | undefined;

  url: any;
  constructor(private api: ApiService, private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.url == undefined) {
      this.api.getBytes('Imagem/DownloadImage?refImage=' + this.idImage).
        then(blob => {

          const binaryData = [];
          binaryData.push(blob);
          var arr = new Response(blob).arrayBuffer();
          arr.then((res) => {
            var url = Buffer.from(res).toString('base64');
            this.url = this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + url);
          })

        }).catch(err => {
          console.log(err);
          this.url = 'assets/noimage.png';

        });
    }
  }
}
